// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WidgetWrapper-module_loaderOverlay__qSctA {
    opacity: 0.4;
    z-index: 3000;
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/WidgetWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".loaderOverlay {\n    opacity: 0.4;\n    z-index: 3000;\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderOverlay": `WidgetWrapper-module_loaderOverlay__qSctA`
};
export default ___CSS_LOADER_EXPORT___;
